<template>
  <div class="section_gap_x">
    <section v-if="!isReadyToAcceptPayment && cart.summary.order_id" class="container_section">
        <div>
            <LoaderRound v-if="isFetchingOrder" />
        </div>
        <div v-if="isDetailsShow">
            <p class="paragraph paragraph--black">
                {{$t("CATELOGUE_ORDER_PAYMENT.QUEUE_TABLE.ORDER_ID")}}
                {{orderSummary.order_id}}
            </p>
            <p class="paragraph paragraph--black">
                {{$t("CATELOGUE_ORDER_PAYMENT.QUEUE_TABLE.ORDER_DATE")}}
                {{orderSummary.createdAt}}
            </p>
            <p class="paragraph paragraph--black">{{count}} {{$t("CATELOGUE_ORDER_PAYMENT.HEADER.DESCRIPTION")}}</p>
        </div>
        <OrderItemsBreakdownTable
            v-if="isDetailsShow"
            :order_items="orderSummary.order_items"
            :cols="cols"
            :summary="orderSummary"
        />
        <div>
            <p class="sp_title_md description">{{distanceBasedMsg}}</p>
        </div>
        <div v-if="!isHideAllBtn ||  !isFetchingOrder">
            <shop-button
                v-if="isCancelOrReorderBtn === 'confirm'"
                className="confirm_btn"
                :isLoading="isConfirmOrderLoading"
                @click="confirmFinalOrderHandler"
            >Confirm</shop-button>

            <shop-button
                v-if="!isHideCancelBtn"
                className="mx-auto"
                @click="cancelOrderHandler"
                :disabled="isReadyToAcceptPayment"
                :isLoading="isOrderCancelLoading"
            >{{$t("CATELOGUE_ORDER_PAYMENT.CANCEL_BTN")}}</shop-button>
        </div>
    </section>

    <section v-if="cart.summary.allowToReOrder" class="container section_gap_y">
        <div class="title_header text_center section_gap_y">
          <p class="sp_title_md description">{{$t("PRODUCT.ORDER_MSG.CANCEL_MSG")}}</p>
        </div>
        <shop-button
            :isLoading="isConfirmOrderLoading"
            className="section_gap_y"
            @click="reOrderHandler"
        >{{$t("PRODUCT.ORDER_MSG.RE_ORDER_BTN")}}</shop-button>
    </section>

    <!--
        <section v-if="isReadyToAcceptPayment" class="container container_payment">
        <div class="title_header text_center">
          <p class="shop_label sp_title_lg">{{$t("CATELOGUE_ORDER_PAYMENT.HEADER.LABEL")}} {{cart.summary.order_id}}</p>
          <p class="sp_title_md description">{{$t("CATELOGUE_ORDER_PAYMENT.HEADER.PAYMENT_DESCRIPTION")}}</p>
        </div>
        <div class="qr_code_wrapper">

        </div>
    </section>
    -->



    <section>
        <order-list />
    </section>
  </div>
</template>

<script>
import ShopButton from '../../../components/ShopButton.vue';
import orderApi from "../../../api/orderApi";
import {StorageHelpers,SHOP_CONSTANT} from "./merchantHelper";
import alertMixin from 'shared/mixins/alertMixin';
import OrderList from './OrderList.vue';
import OrderItemsBreakdownTable from "./queue/OrderItemsBreakdownTable.vue"
import moment from "moment";
 import LoaderRound from '../components/LoaderRound.vue';

export default {
    components: { ShopButton, OrderList,  OrderItemsBreakdownTable, LoaderRound, },
    mixins:[alertMixin],
    data() {
        return {
            isReadyToAcceptPayment:false,
            count: null,
            cart: {summary:{}},
            isOrderCancelLoading:false,
            distanceBasedMsg: '',
            isCancelOrReorderBtn:false,
            isConfirmOrderLoading: false,
            isHideAllBtn: false,
            cols: [
                { key: 'item_name', name: 'Name', visible: true, type: 'default' },
                { key: 'item_price', name: 'Price', visible: true, type: 'default' },
                { key: 'quantity', name: 'Quantity', visible: true, type: 'default' },
                { key: 'total', name: 'Total', visible: true, type: 'default' },
            ],
            isFetchingOrder: false,
            isDetailsShow: false,
        };
    },
    mounted(){
        this.getOrdersAhead();
        bus.$on(SHOP_CONSTANT.EVENTS.ORDER_QUEUE_UPDATED,(data)=>{
            // console.log('webhook data = ',data);
            this.getOrdersAhead(data);
        }),
        this.trackUserAndConfirmOrder();
        this.getOrderDetailsById();
    },
    computed:{
        currentCart(){
            return this.$store.getters["carts/getCurrentCart"](this.$route.params.accountId);
        },
        orderSummary(){
            return {
                createdAt: moment(this.currentCart?.summary?.createdAt).format("dddd, MMMM D, YYYY h:mm A"),
                order_id: this.currentCart?.summary?.order_id,
                order_items: this.currentCart?.order_items || [],
                currency: this.currentCart?.currency,
                grantTotal: this.currentCart?.summary?.grantTotal || 0,
                sst: this.currentCart?.summary?.sst || 0,
                discount_total: this.currentCart?.summary?.discount_total || 0,
                paid_total: this.currentCart?.summary?.paid_total || 0,
                balance: this.currentCart?.summary.balance || 0,
            }
        },
        isReadyToAcceptPayment(){
            return this.count <= 3;
        },
        isHideCancelBtn(){
            let hide = false;
            if (this.cart.summary.order_status === 'out_for_delivery') {
                hide = true;
            }
            if (this.cart.summary.order_status === 'collected') {
                hide = true;
            }
            return hide;
        },
    },
    watch:{
      '$route.params.accountId'(){
        this.getOrdersAhead();
      },
    },
     beforeDestroy() {
        clearInterval(this.trackUserInterval);
    },
    methods:{
        async getOrdersAhead(webHookData=null){
            try {
                const accountId = this.$route.params.accountId;
                this.isCancelOrReorderBtn = null;

                this.cart = StorageHelpers.getCartById(accountId);

                if (!this.cart?.summary?.order_id) {
                    if (this.cart.summary.allowToReOrder) {
                        this.isCancelOrReorderBtn = 're-order';
                    }else{
                        // this.showAlert(this.$t("CATELOGUE_ORDER_PAYMENT.ALERT_MSG.EMPTY_ORDER"));
                        // return to order page
                        this.$router.push(`/app/accounts/${this.$route.params.accountId}`)
                    }

                    return
                }else if (this.cart.summary.order_status === SHOP_CONSTANT.ORDER_STATUS.COMPLETED) {
                    this.isReadyToAcceptPayment = true;
                    return
                }


                const {data} = await orderApi.getOrdersAhead(this.cart.summary.order_id);
                this.count = data.count;

                // if no order id just return
                if (!StorageHelpers.getCartById(accountId)?.summary?.order_id) {
                    console.log("Returning hardly");
                    return
                }
                const merchant = StorageHelpers.getMerchantById(accountId);
                // only if merchant address available and user georestrict=true
                let distance = null;
                if (merchant.georestrict && merchant.address) {
                    const userLocation = await this.getUserLocation();
                    distance =  this.getDistanceFromLatLonInKm(merchant.address,userLocation);
                    console.log({shopLocation:merchant.address,userLocation,distance}); // don't delete
                }

                // internal sub method to handle order pack and deliver. Move it outside to reuse to call when webhook triger
                const handlePackAndDeliver = async (isWithinGeoFence) =>{
                    // !isWithinGeoFence OR !georestrict
                    if (!isWithinGeoFence || !merchant.georestrict) {  // Decision 02
                        // if order=packed,geofence=off and delivery=false "Please proceed to collect your from our shop at {{address}"
                        // this.distanceBasedMsg = 'Your order is being proceed. Plesae, go to shop and collect the order';
                        if ((this.cart.summary.order_status === SHOP_CONSTANT.ORDER_STATUS.FRESH)&& !merchant.payment_before_order) {
                            // If geolocation is not on, immediately call confirm_order api endpoint.
                            const response = await orderApi.confirmOrder(this.cart.summary.order_id)
                            this.cart.summary.order_status = SHOP_CONSTANT.ORDER_STATUS.PENDING;
                            StorageHelpers.updateCartById(this.$route.params.accountId,this.cart);
                        }
                    }
                    // order is packed: webhook.delivery = "self_collect", and order id is for this order
                    const {ORDER_DELIVERY:{DELIVERY,SELF_COLLECT},ORDER_STATUS:{PACKED,PAID,DELIVERED}} = SHOP_CONSTANT;
                    const cartStatus = this.cart?.summary?.order_status;
                    const deliveryType = this.cart?.summary?.delivery;
                    if (cartStatus === PACKED) {
                        // if (!merchant.delivery) {}
                        if (deliveryType === DELIVERY) {
                            // open shipment form
                            this.distanceBasedMsg = `We are preparing your order for shipment`;
                        }else if (deliveryType === SELF_COLLECT) {
                            // disable all buttons: cancel btn
                            this.isHideAllBtn = true;
                            this.distanceBasedMsg = `Please proceed to collect your order from our shop at ${this.formatAddress(merchant.address)}`;
                        }
                        // this.notifyShopMessage('Order is packed',this.distanceBasedMsg)
                    }
                    // hide button when out for delivered
                    if (cartStatus === DELIVERED || webHookData?.order_status === DELIVERED) {
                        this.isHideAllBtn = true;
                    }
                    // if order is paid, hide cancel button
                    if (cartStatus === PAID) {
                        this.isHideAllBtn = true;
                    }
                    // write more logic here
                }
                // new condition and workflow
                if (merchant.georestrict) {
                    // if georestrict, distance based conditions
                    if (data.count <= 5) {
                        // start traking when order queue is less than 5 as process start,
                        if (!this.cart.summary.processStartTime) {
                            this.cart.summary.processStartTime = Date.now();
                            StorageHelpers.updateCartById(this.$route.params.accountId,this.cart);
                        }
                        // if user is 20m radious from shop, show confirm btn
                        const max_delivery_range = parseInt(merchant.max_delivery_range);
                        // if (distance <= 20) {
                        if (distance <= max_delivery_range) {
                            // Set order status to pending. Ask customer to go and collect the order
                            this.distanceBasedMsg =merchant.delivery ? "Your order is being processed.": `Please proceed to our shop at ${this.formatAddress(merchant.address)}, your order will be ready shortly`;
                            if (this.cart.summary.order_status === SHOP_CONSTANT.ORDER_STATUS.FRESH) {
                                // also call confirm_order API to change status on database
                                const response = await orderApi.confirmOrder(this.cart.summary.order_id)
                                // this.notifyShopMessage('Order is packed',this.distanceBasedMsg)
                                // call payment API and ask for payment
                                if (merchant.payment_before_order) {
                                    await this.completePayment(this.cart)
                                }else{
                                    this.cart.summary.order_status = SHOP_CONSTANT.ORDER_STATUS.PENDING;
                                    StorageHelpers.updateCartById(this.$route.params.accountId,this.cart);
                                }
                            }
                        }else{
                            // Give customer 5 (?)minutes. Ask customer to go to area or order will be cancel
                            const processStartTime = this.cart.summary.processStartTime || Date.now();
                            const add15Minutes = new Date(processStartTime + 15 * 60000).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });

                            const createdTimeDiffMinutes = Math.floor((Date.now() - this.cart.summary.createdAt) / (1000 * 60));
                            const processTimeDiffMinutes = Math.floor((Date.now() - this.cart.summary.processStartTime) / (1000 * 60));
                            this.distanceBasedMsg =merchant.delivery ? "Your order is being processed.": `Please proceed to our shop at ${this.formatAddress(merchant.address)} within the next ${15 - processTimeDiffMinutes} minutes. Your order will be automatically cancelled by ${add15Minutes} if you are not present.`;
                            // this.notifyShopMessage('Order is packed',this.distanceBasedMsg)
                            if (processTimeDiffMinutes > 15) {
                                // handlePackAndDeliver(true) // I think it is wrong logic
                            }

                            // cancel the order if not within 15 minutes after process start, delivery:false, order created atleast 15 mins ago
                            if ((processTimeDiffMinutes > 15)&& !merchant.delivery && (createdTimeDiffMinutes > 15)) {
                                // allow atleast 5 minutes to cancel order
                                const {data:cancelData} = await orderApi.cancelOrder(this.cart.summary.order_id)
                                if (cancelData.success) {
                                    // remove the order_id from cart and add as allowToReOrder:true
                                    this.cart.summary.allowToReOrder = true;
                                    this.cart.summary.order_id = null;
                                    this.cart.summary.order_status = SHOP_CONSTANT.ORDER_STATUS.CANCELED;

                                    StorageHelpers.updateCartById(accountId,this.cart);
                                    this.isCancelOrReorderBtn = 're-order';
                                }
                            }

                        }
                    }else{
                        // when queue is nore than 5
                        // this.distanceBasedMsg =merchant.delivery ? "Your order is being processed.": `Your order is being processed.`;
                    }

                }else{
                    // call confirm_order API if merchant.georestrict = false;
                    // if not georestrict, ->pack->delivery->ask delivery address
                    await handlePackAndDeliver(false);
                }

                // hide cancel or confirm button if status is paid
                if (this.cart.summary.order_status === SHOP_CONSTANT.ORDER_STATUS.PAID) {
                    this.isHideAllBtn = true;
                }

            } catch (error) {
                console.log(error,"ER=",error.message);
                if (error.code === 1 || error.code === 2 || error.code === 3) {
                    // Location Track Err: 1 = PERMISSION_DENIED, 2=POSITION_UNAVAILABLE, 3=TIMEOUT
                    return
                }
                // this.showAlert(`Failed to track order queue`);
                this.showAlert(this.$t("CATELOGUE_ORDER_PAYMENT.ALERT_MSG.TRACK_ORDER_ERR"));
            }
        },
        async cancelOrderHandler(){
            try {
                this.isOrderCancelLoading = true;
                const {data} = await orderApi.cancelOrder(this.cart.summary.order_id);
                if (data.success) {
                    // delete the cart from cart list
                    // const existingCart = StorageHelpers.deleteCartByAccountId(this.$route.params.accountId);
                    // bus.$emit('cart_updated_event',existingCart);

                    // do in vuex store
                    await this.$store.dispatch("carts/deleteCartByAccountIdAndOrderId",{
                        accountId: this.$route.params.accountId,
                        order_id: this.cart.summary.order_id,
                    })

                    this.$router.push(`/app/accounts/${this.$route.params.accountId}`)
                    this.showAlert(this.$t("CATELOGUE_ORDER_PAYMENT.ALERT_MSG.ORDER_CANCEL_SUCCESS"));
                }else{
                    this.showAlert(this.$t("PRODUCT.ORDER_MSG.CANCEL_FAIL_MSG"));
                }
                this.isOrderCancelLoading = false;
            } catch (error) {
                console.log(error);
                this.isOrderCancelLoading = false;
                this.showAlert(this.$t("CATELOGUE_ORDER_PAYMENT.ALERT_MSG.ORDER_CANCEL_FAIL"));
            }

        },
         async confirmFinalOrderHandler(){
             try {
                this.isConfirmOrderLoading = true;
                 const {data} = await orderApi.confirmOrder(this.cart.summary.order_id);
                if (data?.success) {
                    this.showAlert(this.$t("PRODUCT.ORDER_MSG.CONFIRM_SUCCESS_MSG"));
                }
                this.isConfirmOrderLoading = false;
            } catch (error) {
                console.log(error);
                this.showAlert(this.$t("PRODUCT.ORDER_MSG.CONFIRM_ERR_MSG"));
                this.isConfirmOrderLoading = false;
            }
        },
         async reOrderHandler(){
             try {
                this.isConfirmOrderLoading = true;
                const userInfo = StorageHelpers.getUserContactInfo();
                // call API to create order
                const payload = {
                    currency : this.cart.currency,
                    order_items: this.cart.order_items.map((item)=>{
                        return {
                            item_price: item.item_price,
                            quantity:item.orderQuantity,
                            catalog_item_id: item.catalog_item_id,
                        }
                    }),
                    contact: {
                        name: userInfo.name,
                        phone_number: userInfo.phone_number,
                    }
                }
                const {data} = await orderApi.createOrder(payload);

                if (data.id) {
                    // store the order id
                    this.cart.summary.order_id = data.id;
                    this.cart.summary.contact_id = data.contact.id;
                    this.cart.summary.pubsub_token = data.contact.pubsub_token;
                    this.cart.summary.order_status = SHOP_CONSTANT.ORDER_STATUS.PENDING;
                    this.cart.summary.allowToReOrder = false;
                    this.cart.summary.createdAt = Date.now();
                    this.cart.summary.processStartTime = null;

                    StorageHelpers.updateCartById(this.$route.params.accountId,this.cart);

                    this.$router.push(`/app/accounts/${this.$route.params.accountId}/payment`).catch(err => {});
                    location.reload();
                }

                this.showAlert(this.$t("PRODUCT.ORDER_MSG.CREATE_SUCCESS_MSG"));

                this.isConfirmOrderLoading = false;
            } catch (error) {
                console.log(error);
                this.showAlert(this.$t("PRODUCT.ORDER_MSG.CREATE_ERR_MSG"));
                this.isConfirmOrderLoading = false;
            }
        },
        getUserLocation() {
            const options = {
                enableHighAccuracy: true,
                maximumAge: 0
            }
            return new Promise((resolve, reject) => {
                navigator.geolocation.getCurrentPosition(position => {
                        const userLocation = {
                            latitude: position.coords.latitude,
                            longitude: position.coords.longitude
                        }
                        resolve(userLocation);
                    },
                    error => {
                        reject(error);
                    },
                    options,
                );
            });
        },

        getDistanceFromLatLonInKm(merchantLocation,userLocation) {
            const {latitude:lat1,longitude:lon1} = merchantLocation;
            const {latitude:lat2,longitude:lon2} = userLocation;
            var R = 6371; // Radius of the earth in km
            var dLat = this.deg2rad(lat2-lat1);  // deg2rad below
            var dLon = this.deg2rad(lon2-lon1);
            var a =
                Math.sin(dLat/2) * Math.sin(dLat/2) +
                Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) *
                Math.sin(dLon/2) * Math.sin(dLon/2);
            var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
            var d = R * c; // Distance in km
            return d*1000;  // distance in meter by multiplying by 1000
        },

        deg2rad(deg) {
            return deg * (Math.PI/180)
        },
        formatAddress(address) {
            const { city, line1, line2, state } = address;
            const parts = [];
            if (line1) parts.push(line1);
            if (line2) parts.push(line2);
            if (city) parts.push(city);
            if (state) parts.push(state);
            return parts.join(', ');
        },
        async trackUserAndConfirmOrder(){
            // check conditions and call confirm order API
            this.trackUserInterval = setInterval(async() => {
                // console.log('conditionally call confirm_order API');
                    const accountId = this.$route.params.accountId;
                if (!StorageHelpers.getCartById(accountId)?.summary?.order_id) {
                    return
                }
                const merchant = StorageHelpers.getMerchantById(accountId);
                const cart = StorageHelpers.getCartById(accountId);
                if (merchant.georestrict) {
                    const userLocation = await this.getUserLocation();
                    const distance = this.getDistanceFromLatLonInKm(merchant.address,userLocation);
                    // console.log({shopLocation:merchant.address,userLocation,distance}); // don't delete
                    // check:order.status=fresh &&distance > radius,
                    const max_delivery_range = parseInt(merchant.max_delivery_range);  // before we were checking 20m
                    // call confirm API if within 20 meters
                    // if ((cart.summary.order_status === SHOP_CONSTANT.ORDER_STATUS.FRESH) && (distance <= 20)) {
                    if ((cart.summary.order_status === SHOP_CONSTANT.ORDER_STATUS.FRESH) && (distance <= max_delivery_range)) {
                            // call confirm API
                            const response = await orderApi.confirmOrder(cart.summary.order_id)
                            if (merchant.payment_before_order) {
                                await this.completePayment(cart)
                            }
                            cart.summary.order_status = SHOP_CONSTANT.ORDER_STATUS.PENDING;
                            StorageHelpers.updateCartById(this.$route.params.accountId,cart);
                    }

                }


            }, 10*1000);
        },
        async completePayment(cart){
            const merchant = StorageHelpers.getMerchantById(this.$route.params.accountId);
            // geo on, status fresh, receive payment before order, pay now, local update paid
            if (merchant.georestrict && merchant.payment_before_order && (cart.summary.order_status === SHOP_CONSTANT.ORDER_STATUS.FRESH)) {
                const {data:payRes} = await orderApi.getPaymentLink(cart.summary.order_id,{
                    order_date: new Date().toISOString(),
                })

                if (payRes.payment_link) {
                    // update paid status
                    cart.summary.order_status = SHOP_CONSTANT.ORDER_STATUS.PAID;
                    StorageHelpers.updateCartById(this.$route.params.accountId,cart);
                    const link = document.createElement('a');
                    link.href = payRes.payment_link;
                    link.rel = 'noopener noreferrer';
                    document.body.appendChild(link)
                    link.click();
                    document.body.removeChild(link);
                }
            }
        },
        async getOrderDetailsById(){
            try {
                this.isFetchingOrder = true;
                const payload = {
                    contact_id:  this.currentCart?.summary?.contact_id,
                    order_id:  this.currentCart?.summary?.order_id,
                }
                const {data} = await orderApi.fetch_shop_order_detail(payload);
                const newCart = {
                    ...this.currentCart,
                    summary: {
                        ...this.currentCart.summary,
                        grantTotal: data.grand_total || 0,
                        discount_total: data.discount_total || 0,
                        paid_total: data.paid_total || 0,
                        balance: data.grand_total - data.paid_total,
                    },
                }

                const oldItems = this.currentCart.summary.order_items || [];

                const updatedItems = data.order_items.map(apiItem => {
                    const oldItem = oldItems.find(el=>el.varient_id === apiItem.catalog_item_id);
                    console.log({oldItem,apiItem,oldItems});
                    return {
                        item_price: apiItem.item_price,
                        orderQuantity: apiItem.quantity,
                        catalog_item_id: oldItem?.catalog_item_id || apiItem.catalog_item_id,
                        catalog_title: oldItem?.varient_title || apiItem.item_name,
                        varient_id: apiItem.catalog_item_id,
                        varient_title:oldItem?.varient_title || apiItem.item_name,
                        display_title: apiItem.item_name,
                        image_link: oldItem?.image_link || "",
                        total: apiItem.item_price *  apiItem.quantity
                    }
                })
                console.log("updatedItems",updatedItems,);
                // update to card
                await this.$store.dispatch("carts/updateCartById",{
                    accountId: this.$route.params.accountId,
                    cart: newCart,
                })

                this.isFetchingOrder = false;
                this.isDetailsShow = true;
            } catch (error) {
                console.log(error);
                this.isFetchingOrder = false;
                this.showErrAlert(error,`Failed to get details`);
            }
        },




        // end methods
    },

}
</script>

<style lang="scss" scoped>
.text_center{
    text-align: center;
}
.title_header{
  .description{
    font-weight: 500;
    color: var(--txt-secondary-light);
  }
}
.mx-auto{
  margin-left: auto;
  margin-right: auto;
}

.container{
    // calc = padding - navHeight
    // min-height: calc(100vh - 2* 2rem - 15px);
    display: grid;
    grid-template-rows: 1fr 1.5fr 1fr;
    justify-items: center;
    align-items: center;
}

.container_section{
    // width: ;
}

.queue_number{
    font-size: 10rem;
    font-weight: 700;
    color: var(--txt-secondary-light);
    width: fit-content;
    margin: auto;
}
.view_btn{
    width: fit-content;
    margin: auto auto 40px auto;
}
.container_payment{
    grid-template-rows: 1fr 2fr;

    .qr_code_wrapper{
        background-color: var(--bg-secondary);
        border-radius: 8px;
        width: 300px;
        height: 300px;
        margin-bottom: 25px;
    }
}

.confirm_btn{
    margin: 12px auto;
}
</style>